import { render, staticRenderFns } from "./GlobalSearchRoutes.vue?vue&type=template&id=e17d18f8&"
import script from "./GlobalSearchRoutes.vue?vue&type=script&lang=ts&"
export * from "./GlobalSearchRoutes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports